/**
 * ██████╗   ██████╗     ███╗   ██╗  ██████╗ ████████╗    ███████╗ ██████╗  ██╗ ████████╗   
 * ██╔══██╗ ██╔═══██╗    ████╗  ██║ ██╔═══██╗╚══██╔══╝    ██╔════╝ ██╔══██╗ ██║ ╚══██╔══╝
 * ██║  ██║ ██║   ██║    ██╔██╗ ██║ ██║   ██║   ██║       █████╗   ██║  ██║ ██║    ██║   
 * ██║  ██║ ██║   ██║    ██║╚██╗██║ ██║   ██║   ██║       ██╔══╝   ██║  ██║ ██║    ██║   
 * ██████╔╝ ╚██████╔╝    ██║ ╚████║ ╚██████╔╝   ██║       ███████╗ ██████╔╝ ██║    ██║   
 * ╚═════╝   ╚═════╝     ╚═╝  ╚═══╝  ╚═════╝    ╚═╝       ╚══════╝ ╚═════╝  ╚═╝    ╚═╝   
 * 
 * This file is generated automatically. Do not edit it directly, your changes will be overwritten.
 * This file is not even tracked in git. It is generated before each build with values that originate
 * in figma.
 */


@import './breakpoints.scss';

//==[ Primitives: Color ]=====================================================//

$t-color-black: var(--t-color-black);
$immu-color-black: #000000;
$t-color-white: var(--t-color-white);
$immu-color-white: #ffffff;
$t-color-amethyst: var(--t-color-amethyst);
$immu-color-amethyst: #55489d;
$t-color-midnight: var(--t-color-midnight);
$immu-color-midnight: #3a4458;
$t-color-mint: var(--t-color-mint);
$immu-color-mint: #4db595;
$t-color-orange: var(--t-color-orange);
$immu-color-orange: #ef6528;
$t-color-periwinkle: var(--t-color-periwinkle);
$immu-color-periwinkle: #7e9cd1;
$t-color-cloud-gray: var(--t-color-cloud-gray);
$immu-color-cloud-gray: #c8c9c4;
$t-color-stone: var(--t-color-stone);
$immu-color-stone: #7d7370;
$t-color-mauve: var(--t-color-mauve);
$immu-color-mauve: #a67d97;
$t-color-champagne: var(--t-color-champagne);
$immu-color-champagne: #fce2d4;
$t-color-deep-space: var(--t-color-deep-space);
$immu-color-deep-space: #222a3a;
$t-color-light-gray: var(--t-color-light-gray);
$immu-color-light-gray: #f5f5f5;

:root {
  --t-color-black: #000000;
  --t-color-white: #ffffff;
  --t-color-amethyst: #55489d;
  --t-color-midnight: #3a4458;
  --t-color-mint: #4db595;
  --t-color-orange: #ef6528;
  --t-color-periwinkle: #7e9cd1;
  --t-color-cloud-gray: #c8c9c4;
  --t-color-stone: #7d7370;
  --t-color-mauve: #a67d97;
  --t-color-champagne: #fce2d4;
  --t-color-deep-space: #222a3a;
  --t-color-light-gray: #f5f5f5;
}

//==[ Primitives: Spacing ]===================================================//

$t-sp-0: var(--t-sp-0);
$immu-sp-0: 0px;
$t-sp-4: var(--t-sp-4);
$immu-sp-4: 4px;
$t-sp-8: var(--t-sp-8);
$immu-sp-8: 8px;
$t-sp-16: var(--t-sp-16);
$immu-sp-16: 16px;
$t-sp-24: var(--t-sp-24);
$immu-sp-24: 24px;
$t-sp-32: var(--t-sp-32);
$immu-sp-32: 32px;
$t-sp-40: var(--t-sp-40);
$immu-sp-40: 40px;
$t-sp-48: var(--t-sp-48);
$immu-sp-48: 48px;
$t-sp-56: var(--t-sp-56);
$immu-sp-56: 56px;
$t-sp-64: var(--t-sp-64);
$immu-sp-64: 64px;
$t-sp-80: var(--t-sp-80);
$immu-sp-80: 80px;
$t-sp-120: var(--t-sp-120);
$immu-sp-120: 120px;

:root {
  --t-sp-0: 0px;
  --t-sp-4: 4px;
  --t-sp-8: 8px;
  --t-sp-16: 16px;
  --t-sp-24: 24px;
  --t-sp-32: 32px;
  --t-sp-40: 40px;
  --t-sp-48: 48px;
  --t-sp-56: 56px;
  --t-sp-64: 64px;
  --t-sp-80: 80px;
  --t-sp-120: 120px;
}

//==[ Primitives: Font ]======================================================//

$t-font-family-base: var(--t-font-family-base);
$immu-font-family-base: 'Open Sans', sans-serif;
$t-font-weight-light: var(--t-font-weight-light);
$immu-font-weight-light: 300;
$t-font-weight-regular: var(--t-font-weight-regular);
$immu-font-weight-regular: 400;
$t-font-weight-semibold: var(--t-font-weight-semibold);
$immu-font-weight-semibold: 600;
$t-font-weight-bold: var(--t-font-weight-bold);
$immu-font-weight-bold: 700;
$t-font-weight-extra-bold: var(--t-font-weight-extra-bold);
$immu-font-weight-extra-bold: 800;

:root {
  --t-font-family-base: 'Open Sans', sans-serif;
  --t-font-weight-light: 300;
  --t-font-weight-regular: 400;
  --t-font-weight-semibold: 600;
  --t-font-weight-bold: 700;
  --t-font-weight-extra-bold: 800;
}

//==[ Semantics: Typography ]=================================================//

$t-font-size-heading-xl--mobile: var(--t-font-size-heading-xl--mobile);
$immu-font-size-heading-xl--mobile: 3rem;
$t-font-size-heading-lg--mobile: var(--t-font-size-heading-lg--mobile);
$immu-font-size-heading-lg--mobile: 2rem;
$t-font-size-heading-md--mobile: var(--t-font-size-heading-md--mobile);
$immu-font-size-heading-md--mobile: 1.5rem;
$t-font-size-heading-sm--mobile: var(--t-font-size-heading-sm--mobile);
$immu-font-size-heading-sm--mobile: 1.25rem;
$t-font-size-heading-xxl--mobile: var(--t-font-size-heading-xxl--mobile);
$immu-font-size-heading-xxl--mobile: 4rem;
$t-font-size-heading-xs--mobile: var(--t-font-size-heading-xs--mobile);
$immu-font-size-heading-xs--mobile: 1.125rem;
$t-line-height-sm--mobile: var(--t-line-height-sm--mobile);
$immu-line-height-sm--mobile: 120%;
$t-line-height-md--mobile: var(--t-line-height-md--mobile);
$immu-line-height-md--mobile: 130%;
$t-line-height-lg--mobile: var(--t-line-height-lg--mobile);
$immu-line-height-lg--mobile: 140%;
$t-font-size-body-lg--mobile: var(--t-font-size-body-lg--mobile);
$immu-font-size-body-lg--mobile: 1.25rem;
$t-font-size-body-md--mobile: var(--t-font-size-body-md--mobile);
$immu-font-size-body-md--mobile: 1.125rem;
$t-font-size-body-sm--mobile: var(--t-font-size-body-sm--mobile);
$immu-font-size-body-sm--mobile: 1rem;
$t-font-size-body-xs--mobile: var(--t-font-size-body-xs--mobile);
$immu-font-size-body-xs--mobile: 1rem;
$t-font-size-button-md--mobile: var(--t-font-size-button-md--mobile);
$immu-font-size-button-md--mobile: 1.25rem;
$t-font-size-button-sm--mobile: var(--t-font-size-button-sm--mobile);
$immu-font-size-button-sm--mobile: 1.125rem;
$t-font-size-button-lg--mobile: var(--t-font-size-button-lg--mobile);
$immu-font-size-button-lg--mobile: 1.5rem;
$t-header-size--mobile: var(--t-header-size--mobile);
$immu-header-size--mobile: true;

$t-font-size-heading-xl--desktop: var(--t-font-size-heading-xl--desktop);
$immu-font-size-heading-xl--desktop: 4rem;
$t-font-size-heading-lg--desktop: var(--t-font-size-heading-lg--desktop);
$immu-font-size-heading-lg--desktop: 3rem;
$t-font-size-heading-md--desktop: var(--t-font-size-heading-md--desktop);
$immu-font-size-heading-md--desktop: 2rem;
$t-font-size-heading-sm--desktop: var(--t-font-size-heading-sm--desktop);
$immu-font-size-heading-sm--desktop: 1.5rem;
$t-font-size-heading-xxl--desktop: var(--t-font-size-heading-xxl--desktop);
$immu-font-size-heading-xxl--desktop: 5rem;
$t-font-size-heading-xs--desktop: var(--t-font-size-heading-xs--desktop);
$immu-font-size-heading-xs--desktop: 1.25rem;
$t-line-height-sm--desktop: var(--t-line-height-sm--desktop);
$immu-line-height-sm--desktop: 120%;
$t-line-height-md--desktop: var(--t-line-height-md--desktop);
$immu-line-height-md--desktop: 130%;
$t-line-height-lg--desktop: var(--t-line-height-lg--desktop);
$immu-line-height-lg--desktop: 140%;
$t-font-size-body-lg--desktop: var(--t-font-size-body-lg--desktop);
$immu-font-size-body-lg--desktop: 1.5rem;
$t-font-size-body-md--desktop: var(--t-font-size-body-md--desktop);
$immu-font-size-body-md--desktop: 1.25rem;
$t-font-size-body-sm--desktop: var(--t-font-size-body-sm--desktop);
$immu-font-size-body-sm--desktop: 1.125rem;
$t-font-size-body-xs--desktop: var(--t-font-size-body-xs--desktop);
$immu-font-size-body-xs--desktop: 1rem;
$t-font-size-button-md--desktop: var(--t-font-size-button-md--desktop);
$immu-font-size-button-md--desktop: 1.25rem;
$t-font-size-button-sm--desktop: var(--t-font-size-button-sm--desktop);
$immu-font-size-button-sm--desktop: 1.125rem;
$t-font-size-button-lg--desktop: var(--t-font-size-button-lg--desktop);
$immu-font-size-button-lg--desktop: 1.5rem;
$t-header-size--desktop: var(--t-header-size--desktop);
$immu-header-size--desktop: true;

$t-font-size-heading-xl: var(--t-font-size-heading-xl);
$t-font-size-heading-lg: var(--t-font-size-heading-lg);
$t-font-size-heading-md: var(--t-font-size-heading-md);
$t-font-size-heading-sm: var(--t-font-size-heading-sm);
$t-font-size-heading-xxl: var(--t-font-size-heading-xxl);
$t-font-size-heading-xs: var(--t-font-size-heading-xs);
$t-line-height-sm: var(--t-line-height-sm);
$t-line-height-md: var(--t-line-height-md);
$t-line-height-lg: var(--t-line-height-lg);
$t-font-size-body-lg: var(--t-font-size-body-lg);
$t-font-size-body-md: var(--t-font-size-body-md);
$t-font-size-body-sm: var(--t-font-size-body-sm);
$t-font-size-body-xs: var(--t-font-size-body-xs);
$t-font-size-button-md: var(--t-font-size-button-md);
$t-font-size-button-sm: var(--t-font-size-button-sm);
$t-font-size-button-lg: var(--t-font-size-button-lg);
$t-header-size: var(--t-header-size);

:root {
  --t-font-size-heading-xl--mobile: 3rem;
  --t-font-size-heading-lg--mobile: 2rem;
  --t-font-size-heading-md--mobile: 1.5rem;
  --t-font-size-heading-sm--mobile: 1.25rem;
  --t-font-size-heading-xxl--mobile: 4rem;
  --t-font-size-heading-xs--mobile: 1.125rem;
  --t-line-height-sm--mobile: 120%;
  --t-line-height-md--mobile: 130%;
  --t-line-height-lg--mobile: 140%;
  --t-font-size-body-lg--mobile: 1.25rem;
  --t-font-size-body-md--mobile: 1.125rem;
  --t-font-size-body-sm--mobile: 1rem;
  --t-font-size-body-xs--mobile: 1rem;
  --t-font-size-button-md--mobile: 1.25rem;
  --t-font-size-button-sm--mobile: 1.125rem;
  --t-font-size-button-lg--mobile: 1.5rem;
  --t-header-size--mobile: true;
  --t-font-size-heading-xl--desktop: 4rem;
  --t-font-size-heading-lg--desktop: 3rem;
  --t-font-size-heading-md--desktop: 2rem;
  --t-font-size-heading-sm--desktop: 1.5rem;
  --t-font-size-heading-xxl--desktop: 5rem;
  --t-font-size-heading-xs--desktop: 1.25rem;
  --t-line-height-sm--desktop: 120%;
  --t-line-height-md--desktop: 130%;
  --t-line-height-lg--desktop: 140%;
  --t-font-size-body-lg--desktop: 1.5rem;
  --t-font-size-body-md--desktop: 1.25rem;
  --t-font-size-body-sm--desktop: 1.125rem;
  --t-font-size-body-xs--desktop: 1rem;
  --t-font-size-button-md--desktop: 1.25rem;
  --t-font-size-button-sm--desktop: 1.125rem;
  --t-font-size-button-lg--desktop: 1.5rem;
  --t-header-size--desktop: true;
  --t-font-size-heading-xl: var(--t-font-size-heading-xl--mobile);
  --t-font-size-heading-lg: var(--t-font-size-heading-lg--mobile);
  --t-font-size-heading-md: var(--t-font-size-heading-md--mobile);
  --t-font-size-heading-sm: var(--t-font-size-heading-sm--mobile);
  --t-font-size-heading-xxl: var(--t-font-size-heading-xxl--mobile);
  --t-font-size-heading-xs: var(--t-font-size-heading-xs--mobile);
  --t-line-height-sm: var(--t-line-height-sm--mobile);
  --t-line-height-md: var(--t-line-height-md--mobile);
  --t-line-height-lg: var(--t-line-height-lg--mobile);
  --t-font-size-body-lg: var(--t-font-size-body-lg--mobile);
  --t-font-size-body-md: var(--t-font-size-body-md--mobile);
  --t-font-size-body-sm: var(--t-font-size-body-sm--mobile);
  --t-font-size-body-xs: var(--t-font-size-body-xs--mobile);
  --t-font-size-button-md: var(--t-font-size-button-md--mobile);
  --t-font-size-button-sm: var(--t-font-size-button-sm--mobile);
  --t-font-size-button-lg: var(--t-font-size-button-lg--mobile);
  --t-header-size: var(--t-header-size--mobile);

  @media (--bp-at-least-md) {
    --t-font-size-heading-xl: var(--t-font-size-heading-xl--desktop);
    --t-font-size-heading-lg: var(--t-font-size-heading-lg--desktop);
    --t-font-size-heading-md: var(--t-font-size-heading-md--desktop);
    --t-font-size-heading-sm: var(--t-font-size-heading-sm--desktop);
    --t-font-size-heading-xxl: var(--t-font-size-heading-xxl--desktop);
    --t-font-size-heading-xs: var(--t-font-size-heading-xs--desktop);
    --t-line-height-sm: var(--t-line-height-sm--desktop);
    --t-line-height-md: var(--t-line-height-md--desktop);
    --t-line-height-lg: var(--t-line-height-lg--desktop);
    --t-font-size-body-lg: var(--t-font-size-body-lg--desktop);
    --t-font-size-body-md: var(--t-font-size-body-md--desktop);
    --t-font-size-body-sm: var(--t-font-size-body-sm--desktop);
    --t-font-size-body-xs: var(--t-font-size-body-xs--desktop);
    --t-font-size-button-md: var(--t-font-size-button-md--desktop);
    --t-font-size-button-sm: var(--t-font-size-button-sm--desktop);
    --t-font-size-button-lg: var(--t-font-size-button-lg--desktop);
    --t-header-size: var(--t-header-size--desktop);
  }
}

//==[ Semantics: Color ]======================================================//

$t-color-background-medium: var(--t-color-background-medium);
$immu-color-background-medium: #f5f5f5;
$t-color-background-dark-10: var(--t-color-background-dark-10);
$immu-color-background-dark-10: #0000001a;
$t-color-background-light-70: var(--t-color-background-light-70);
$immu-color-background-light-70: #ffffffb3;
$t-color-background-light: var(--t-color-background-light);
$immu-color-background-light: #ffffff;
$t-color-background-dark: var(--t-color-background-dark);
$immu-color-background-dark: #000000;
$t-color-background-cloud-gray-50: var(--t-color-background-cloud-gray-50);
$immu-color-background-cloud-gray-50: #c8c9c480;
$t-color-text-body-dark: var(--t-color-text-body-dark);
$immu-color-text-body-dark: #000000;
$t-color-text-body-light: var(--t-color-text-body-light);
$immu-color-text-body-light: #ffffff;
$t-color-text-heading-dark: var(--t-color-text-heading-dark);
$immu-color-text-heading-dark: #000000;
$t-color-text-heading-light: var(--t-color-text-heading-light);
$immu-color-text-heading-light: #ffffff;
$t-color-text-button-dark: var(--t-color-text-button-dark);
$immu-color-text-button-dark: #000000;
$t-color-text-button-light: var(--t-color-text-button-light);
$immu-color-text-button-light: #ffffff;
$t-color-text-button-danger: var(--t-color-text-button-danger);
$immu-color-text-button-danger: #ef6528;
$t-color-border-light: var(--t-color-border-light);
$immu-color-border-light: #ffffff;
$t-color-border-dark: var(--t-color-border-dark);
$immu-color-border-dark: #000000;
$t-color-icon-dark: var(--t-color-icon-dark);
$immu-color-icon-dark: #000000;
$t-color-icon-light: var(--t-color-icon-light);
$immu-color-icon-light: #ffffff;

:root {
  --t-color-background-medium: var(--t-color-light-gray);
  --t-color-background-dark-10: #0000001a;
  --t-color-background-light-70: #ffffffb3;
  --t-color-background-light: var(--t-color-white);
  --t-color-background-dark: var(--t-color-black);
  --t-color-background-cloud-gray-50: #c8c9c480;
  --t-color-text-body-dark: var(--t-color-black);
  --t-color-text-body-light: var(--t-color-white);
  --t-color-text-heading-dark: var(--t-color-black);
  --t-color-text-heading-light: var(--t-color-white);
  --t-color-text-button-dark: var(--t-color-black);
  --t-color-text-button-light: var(--t-color-white);
  --t-color-text-button-danger: var(--t-color-orange);
  --t-color-border-light: var(--t-color-white);
  --t-color-border-dark: var(--t-color-black);
  --t-color-icon-dark: var(--t-color-black);
  --t-color-icon-light: var(--t-color-white);
}